import { useCartCountsQuery } from "./useCartCountsQuery";
import { getCurrentCartQuery } from "./useCurrentCartQuery";
const useCartData = (isLoggedIn, currentCart)=>{
    // 자료, 이북 장바구니 조회 query
    const { data  } = getCurrentCartQuery({
        enabled: isLoggedIn && Boolean(currentCart),
        params: {
            cartType: currentCart || "separate"
        }
    });
    const { data: cartCounts  } = useCartCountsQuery({
        enabled: isLoggedIn
    });
    var _data_lineItemsCount;
    const isHandoutItemsNumber = ((_data_lineItemsCount = data === null || data === void 0 ? void 0 : data.lineItemsCount) !== null && _data_lineItemsCount !== void 0 ? _data_lineItemsCount : 0) > 0;
    return {
        data,
        cartCounts,
        isHandoutItemsNumber
    };
};
export default useCartData;
